module.exports = __webpack_public_path__ + "image/header-pic2.png";